// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._28H6wp9yUN-tehdLUv3gAe{text-align:center}._3IYA_zIobOmwdqffZlE_hC{font-size:1.42857rem;font-weight:700;margin:0}._2KZwcFL3_8ceNlO8BnsI7p{font-size:.85714rem;font-weight:700;margin:0}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cheerConfettiBottomBar": "_28H6wp9yUN-tehdLUv3gAe",
	"cheerConfettiBottomBar__title": "_3IYA_zIobOmwdqffZlE_hC",
	"cheerConfettiBottomBar__text": "_2KZwcFL3_8ceNlO8BnsI7p"
};
export default ___CSS_LOADER_EXPORT___;
